import i18n from "i18next";
import { initReactI18next } from "react-i18next";

i18n.use(initReactI18next).init({
  resources: {
    en: {
      translation: {
        welcome: "Welcome",
        buyTicket: "Buy Ticket",
		total: "Total",
		price: "Price",
		processingFee: "Fee",
		end: "End",
		checkout: "Checkout",
		information: "User Information",
		payment: "Choose Payment",
		confirm: "Confirm & Pay",
		name: "Your Name",
		back: "Back",
		status: "Payment Status",
		tryagain: "Sorry , Please try to purchase ticket again !",
		success: "Purchase Successful!",
		successconfirm: "Your ticket has been confirmed.",
		qrcode: "Show this QR code at the entry gate",
		email: "A copy of your ticket has been sent to your email.",
		download: "Download Ticket",
		buy: "Buy Ticket",
		childname : "Child Name",
		group: "Group",
		paysuccess: "Payment Successful!",
		emailmsg: "Thanks for your payment. Confirmation email is sent to your email address."
		
      }
    },
    nl: {
      translation: {
        welcome: "Welkom",
        buyTicket: "Bestel Ticket",
		total: "Totaal",
		price: "Prijs",
		processingFee: "Servicekosten",
		end:"Einde",
		checkout: "Bestellen",
		information: "Gebruikersinformatie",
		payment: "Kies Betaalmethode",
		confirm: "Bestelling Afronden",
		name: "Voorname & Achternaam",
		back: "Terug",
		status: "BETALINGSSTATUS",
		tryagain: "Sorry, probeer het ticket opnieuw te kopen..",
		success: "Aankoop geslaagd!",
		successconfirm: "Je ticket is bevestigd.",
		qrcode: "Toon deze QR-code bij de Ingangspoort.",
		email: "Een kopie van je ticket is naar je e-mail gestuurd.",
		download: "Ticket Downloaden",
		buy: "Ticket Kopen",
		childname : "Naam van kind",
		group: "Groep",
		paysuccess: "Betaling Succesvol!",
		emailmsg: "Bedankt voor uw betaling. U ontvangt een bevestigingsmail op uw e-mailadres."
      }
    }
  },
  lng: localStorage.getItem("lang") || "en",
  fallbackLng: "en",
});

// Save language to localStorage
i18n.on("languageChanged", (lng) => {
  localStorage.setItem("lang", lng);
});

export default i18n;

